import { programTermLabelFromId } from '../../../shared/terms/programTerms';
import type { OrganizationSeason } from '../types';

const ymd = (year: number, month: number, day: number) => `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

/**
 * Central org-season record used to propose partner dates. These defaults are
 * intentionally copied into a partner-season so later org changes never alter
 * a confirmed partner calendar silently.
 */
export function organizationSeasonForTerm(termId: string): Omit<OrganizationSeason, 'id'> | null {
  const match = /^(winter|spring|summer|fall)(\d{4})$/i.exec(termId.trim());
  if (!match) return null;
  const season = match[1].toLowerCase();
  const year = Number(match[2]);
  const windows: Record<string, Omit<OrganizationSeason, 'id' | 'termId' | 'label'>> = {
    winter: {
      planningPeriodStartDate: ymd(year - 1, 9, 1), planningPeriodEndDate: ymd(year - 1, 12, 20),
      registrationStartDate: ymd(year - 1, 10, 1), registrationEndDate: ymd(year - 1, 12, 15),
      defaultProgramStartDate: ymd(year, 1, 5), defaultProgramEndDate: ymd(year, 3, 20),
    },
    spring: {
      planningPeriodStartDate: ymd(year - 1, 11, 1), planningPeriodEndDate: ymd(year, 2, 28),
      registrationStartDate: ymd(year - 1, 12, 1), registrationEndDate: ymd(year, 2, 28),
      defaultProgramStartDate: ymd(year, 3, 1), defaultProgramEndDate: ymd(year, 6, 15),
    },
    summer: {
      planningPeriodStartDate: ymd(year, 1, 15), planningPeriodEndDate: ymd(year, 5, 31),
      registrationStartDate: ymd(year, 3, 1), registrationEndDate: ymd(year, 5, 31),
      defaultProgramStartDate: ymd(year, 6, 1), defaultProgramEndDate: ymd(year, 8, 31),
    },
    fall: {
      planningPeriodStartDate: ymd(year, 3, 1), planningPeriodEndDate: ymd(year, 8, 31),
      registrationStartDate: ymd(year, 5, 1), registrationEndDate: ymd(year, 8, 31),
      defaultProgramStartDate: ymd(year, 9, 1), defaultProgramEndDate: ymd(year, 12, 20),
    },
  };
  return { termId, label: programTermLabelFromId(termId), ...windows[season] };
}

export const ORG_DATE_SOURCE = {
  planningPeriodStartDate: 'org_default', planningPeriodEndDate: 'org_default',
  registrationStartDate: 'org_default', registrationEndDate: 'org_default',
  defaultProgramStartDate: 'org_default', defaultProgramEndDate: 'org_default',
} as const;
